import { CalculatedConsumablesDemandThemeSizeConfig } from './types';

const large: CalculatedConsumablesDemandThemeSizeConfig = {
  calculatedConsumablesDemand: {},
};

export default large;
